/* El panel lateral: 460 de ancho (todo el ancho en celular), blanco, con la
   sombra hacia la izquierda sobre el scrim. Vive en la capa de diálogo: por
   encima de las barras fijas, por debajo del `<dialog>` nativo (top layer). */
.capa {
  position: fixed;
  inset: 0;
  z-index: var(--z-dialog);
}
.scrim {
  position: absolute;
  inset: 0;
  background: var(--scrim-drawer);
  animation: aparecer var(--dur-base) var(--ease-out);
}
.panel {
  position: absolute;
  top: 0;
  right: 0;
  height: 100dvh;
  width: min(var(--w-drawer), 100vw);
  display: flex;
  flex-direction: column;
  background: var(--surface-card);
  color: var(--text-body);
  box-shadow: var(--sh-drawer);
  outline: none;
  animation: entrar var(--dur-base) var(--ease-out);
}
.cuerpo {
  flex: 1;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: var(--s-8);
  padding: 28px 28px var(--s-8);
}
.cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s-5);
}
.pie {
  display: flex;
  flex-wrap: wrap;
  gap: var(--s-4);
  padding: var(--s-6) 28px var(--s-8);
  border-top: var(--bw-hair) solid var(--border-hair);
  background: var(--surface-card);
}
/* El primero de los botones del pie estira; los demás miden lo suyo. Con
   tres, el principal ocupa su propia fila y los otros dos se reparten la
   siguiente: entran mejor que tres al hilo en 460 px. */
.pie > :first-child {
  flex: 1 1 auto;
}
.pie > :first-child:nth-last-child(n + 3) {
  flex-basis: 100%;
}
.pie > :first-child:nth-last-child(n + 3) ~ * {
  flex: 1 1 auto;
}
@keyframes aparecer {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes entrar {
  from {
    transform: translateX(var(--s-9));
    opacity: 0;
  }
  to {
    transform: none;
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .scrim,
  .panel {
    animation: none;
  }
}
